var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 13.3334V20.0001M17.083 9.16676H11.333C8.53274 9.16676 7.13261 9.16676 6.06305 9.71173C5.12224 10.1911 4.35734 10.956 3.87797 11.8968C3.33301 12.9664 3.33301 14.3665 3.33301 17.1668L3.33301 19.1668C3.33301 20.7199 3.33301 21.4965 3.58675 22.109C3.92506 22.9258 4.57397 23.5747 5.39073 23.913C6.0033 24.1668 6.77987 24.1668 8.33301 24.1668V31.2501C8.33301 31.637 8.33301 31.8305 8.34906 31.9935C8.50493 33.5761 9.75703 34.8282 11.3396 34.984C11.5026 35.0001 11.6961 35.0001 12.083 35.0001C12.47 35.0001 12.6634 35.0001 12.8264 34.984C14.409 34.8282 15.6611 33.5761 15.817 31.9935C15.833 31.8305 15.833 31.637 15.833 31.2501V24.1668H17.083C20.0271 24.1668 23.6284 25.7449 26.4068 27.2595C28.0277 28.1431 28.8382 28.5849 29.369 28.5199C29.8612 28.4596 30.2334 28.2386 30.5219 27.8353C30.833 27.4003 30.833 26.5301 30.833 24.7896V8.5439C30.833 6.80342 30.833 5.93318 30.5219 5.49825C30.2334 5.09493 29.8612 4.87393 29.369 4.81364C28.8382 4.74863 28.0277 5.19043 26.4068 6.07402C23.6284 7.58862 20.027 9.16676 17.083 9.16676Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMarketing);
export default __webpack_public_path__ + "react/media/category-marketing.48c23c09b6aeeeb2fa03589dbfdea6dd.svg";
export { ForwardRef as ReactComponent };